export function currency(currency = 'EUR') {
    return function (value) {
       return new Intl.NumberFormat(navigator.language , { style: 'currency', currency: currency }).format(value)
    }
}

function formatSeparators(num) {
    let numParts = num.toString().split('.');
    numParts[0] = numParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    return numParts.join(',');
}
